/**
 * @generated SignedSource<<0fa9e81fa3990515cd6904cf3ec3c123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedFileItem_file$data = {
  readonly id: string;
  readonly name: string | null;
  readonly pages: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly thumbnail: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
  readonly " $fragmentType": "LinkedFileItem_file";
};
export type LinkedFileItem_file$key = {
  readonly " $data"?: LinkedFileItem_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedFileItem_file">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedFileItem_file",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIcon_File"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FilePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "thumbnail",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};
})();

(node as any).hash = "f75301da4a053cc8cc10f13b20716bbf";

export default node;
